import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button, Modal } from 'react-bootstrap';
import NavigationBar from '../components/NavigationBar';
import TrashIcon  from '../../img/trash.svg';
import { useTheme } from '../../ThemeContext';
import '../../styles/ReportedProblemsPage.scss';

function ReportedProblemsPage() {
  const [problems, setProblems] = useState([]);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedProblem, setSelectedProblem] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');

  const { theme } = useTheme();

  useEffect(() => {
    fetch('/admin/get/reported-problems')
      .then((res) => res.json())
      .then((data) => setProblems(data.problems))
      .catch((err) => console.error('Failed to fetch problems:', err));
  }, []);

  const handleDelete = async () => {
  try {
    const res = await fetch(`/admin/delete/reported-problem/${selectedProblem.id}`, { method: 'DELETE' });
    if (res.ok) {
      setProblems(problems.filter(p => p.id !== selectedProblem.id));
      setShowDeleteModal(false);
      setSelectedProblem(null);
      setSuccessMessage('Ziņojums veiksmīgi izdzēsts.');
      setTimeout(() => setSuccessMessage(''), 4000); // pazūd pēc 4 sekundēm
    } else {
      alert('Neizdevās dzēst ziņojumu.');
    }
  } catch (err) {
    console.error('Dzēšanas kļūda:', err);
    alert('Neizdevās dzēst ziņojumu.');
  }
};


  const handleShowViewModal = (problem) => {
    setSelectedProblem(problem);
    setShowViewModal(true);
  };

  const handleShowDeleteModal = (problem) => {
    setSelectedProblem(problem);
    setShowDeleteModal(true);
  };

  const handleCloseModals = () => {
    setShowViewModal(false);
    setShowDeleteModal(false);
    setSelectedProblem(null);
  };

  const truncateText = (text, maxLength = 100) => {
    if (!text) return '';
    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
  };

  return (
    <main className="reported-problems-page" data-theme={theme}>
      <NavigationBar />
      <Container className="py-5">
        <h1 className="text-center mb-4">Reported Problems</h1>
        {successMessage && (
  <div className="alert-wrapper">
    <div className="alert-success">{successMessage}</div>
  </div>
)}
        <Row>
          {problems.length === 0 && (
            <p className="no-problems">No reported problems found.</p>
          )}
          {problems.map((p) => (
            <Col md={6} lg={4} key={p.id} className="mb-3">
              <Card className="problem-card">
                <Card.Body>
                  <Card.Title>{p.first_name}</Card.Title>
                  <Card.Text>
                    {truncateText(p.problem_description, 100)}
                    <Button
                      variant="link"
                      onClick={() => handleShowViewModal(p)}
                      style={{ padding: 0 }}
                    >
                      Lasīt vairāk
                    </Button>
                  </Card.Text>
                 <Button variant="danger" onClick={() => handleShowDeleteModal(p)}>
                  <img src={TrashIcon} alt="Delete" style={{ width: '20px', height: '20px' }} />
                </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>

      {/* Skatīt pilnu aprakstu */}
{/* Apskates modālis - Problēmas apraksts */}
<Modal
  show={showViewModal}
  onHide={handleCloseModals}
  backdrop="static"
  keyboard={false}
  centered
  className="custom-confirmation-modal"
>
  <Modal.Header className="no-close">
    <Modal.Title className="w-100 text-center fw-bold">
      Problēmas apraksts
    </Modal.Title>
  </Modal.Header>
  <Modal.Body
  style={{
    maxHeight: '400px',
    overflowY: 'auto',
    overflowX: 'hidden',
    wordWrap: 'break-word',
    whiteSpace: 'pre-wrap'
  }}
>
    {selectedProblem && (
      <>
        <p className="fs-5"><strong>Vārds:</strong> {selectedProblem.first_name}</p>
        <p className="fs-5">{selectedProblem.problem_description}</p>
        <p className="fs-6 text-muted">
          Ziņots: {new Date(selectedProblem.created_at).toLocaleString()}
        </p>
      </>
    )}
  </Modal.Body>
  <Modal.Footer className="justify-content-center">
    <Button variant="secondary" onClick={handleCloseModals}>
      Aizvērt
    </Button>
  </Modal.Footer>
</Modal>

{/* Dzēšanas apstiprinājuma modālis */}
<Modal
  show={showDeleteModal}
  onHide={handleCloseModals}
  backdrop="static"
  keyboard={false}
  centered
  className="custom-confirmation-modal"
>
  <Modal.Header className="no-close">
    <Modal.Title className="w-100 text-center fw-bold">
      Apstiprināt dzēšanu
    </Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <p className="text-center fs-5 m-0">
      Vai tiešām vēlies dzēst šo ziņojumu no <strong>{selectedProblem?.first_name}</strong>?<br />
      Šo darbību nevar atsaukt.
    </p>
  </Modal.Body>
  <Modal.Footer className="justify-content-center">
    
    <Button variant="secondary" onClick={handleCloseModals}>
      Atcelt
    </Button>
    <Button variant="danger" onClick={handleDelete}>
  <img src={TrashIcon} alt="Dzēst" style={{ width: '20px', height: '20px' }} />
</Button>

  </Modal.Footer>
</Modal>


    </main>
  );
}

export default ReportedProblemsPage;
